import { useState } from "react";

import { IHelpMeChooseDoctorRequest } from "@/models/ApiRequestResponse/patient";

import { postHelpMeChooseDoctorApi } from "@/utils/apis/patient/doctor";

import { INotifyEnum, notify } from "@/utils/toaster";

const useHelpMeChooseDoctor = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const createSupportHandler = async (
    requestBody: IHelpMeChooseDoctorRequest
  ): Promise<void> => {
    try {
      setIsLoading(true);
      const response = await postHelpMeChooseDoctorApi(requestBody);
      if ("result" in response) {
        notify(INotifyEnum.SUCCESS, response.message);
      } else {
        notify(INotifyEnum.ERROR, response?.message);
      }
    } catch (error) {
      notify(INotifyEnum.ERROR, "Failed to process your request.");
      console.error("Error in createSupportHandler:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return { createSupportHandler, isLoading };
};

export default useHelpMeChooseDoctor;
